export default "__VITE_PUBLIC_ASSET__a025e79e__"